import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';

export const TEXT_KEYS = {
    CAPTION: 'friend-referral-program',
    TITLE: 'invitee-page__title',
    REWARD_DESCRIPTION: 'invitee-page__reward-description',
    BUTTON_BUY: 'invitee-page__button-text',
    NOTE: 'invitee-page__message',
    CONJUNCTION_AND_TEXT: 'conjunction_and_text',
    CONJUNCTION_OR_TEXT: 'conjunction_or_text',
    ON_PLATFORM: 'on_platform'
};

export const DEFAULT_STAT_VALUE = '0';

export const GET_ANALYTICS_INVITEE_CLICK_BY_GAME = () => ({
    category: CATEGORY.ACTION,
    action: 'buy the game'
});

export const GET_ANALYTICS_INVITEE_INIT_DATA = () => ({
    flowStep: 'invitee',
    category: CATEGORY.DISPLAY,
    action: 'invitee page'
});
